import { ReactNode } from 'react';

export interface EmptyStateHint {
  icon?: string;
  label: string;
}

interface EmptyStateProps {
  icon: string;
  title: string;
  description?: string;
  action?: ReactNode;
  hintsTitle?: string;
  hints?: EmptyStateHint[];
  compact?: boolean;
}

export default function EmptyState({
  icon,
  title,
  description,
  action,
  hintsTitle,
  hints,
  compact = false,
}: EmptyStateProps) {
  return (
    <div className={compact ? 'text-center py-6' : 'text-center py-12'}>
      <div className={compact ? 'text-3xl mb-2' : 'text-6xl mb-4'}>{icon}</div>
      <p className={`text-gray-500 ${compact ? 'text-sm' : 'text-lg'} mb-2`}>{title}</p>
      {description && <p className="text-gray-400 text-sm">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
      {hints && hints.length > 0 && (
        <div className="mt-8 text-left max-w-xl mx-auto bg-blue-50 border border-blue-200 rounded-lg p-4">
          {hintsTitle && (
            <h3 className="text-sm font-medium text-blue-900 mb-3">{hintsTitle}</h3>
          )}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm text-blue-800">
            {hints.map((hint) => (
              <div key={hint.label} className="flex items-center space-x-2">
                {hint.icon && <span>{hint.icon}</span>}
                <span>{hint.label}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
